import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import * as _ from 'lodash';
import {
  CompanyBeneficialOwner,
  CompanyProfileObject,
} from '../definition/interface/subscription';

export default {
  generatForm(
    entity: CompanyProfileObject,
    formBuilder: UntypedFormBuilder,
  ): UntypedFormGroup {
    const beneficialOwners = entity?.company?.beneficialOwner;
    const beneficialOwnerForm = buildBeneficialOwnerFormArray(
      formBuilder,
      beneficialOwners,
    );
    let formBuilderGroup = formBuilder.group({
      ownerId: [entity.ownerId],
      company: formBuilder.group({
        id: [entity?.company?.id || null],
        accountId: [entity?.company?.accountId || null],
        endDate: [entity?.company?.endDate || null],
        name: [entity?.company?.name || null],
        legalForm: [entity?.company?.legalForm || null],
        representative: [entity?.company?.representative || null],
        representativeFunction: [
          entity?.company?.representativeFunction || null,
        ],
        creationDate: [entity?.company?.creationDate || null],
        taxSystem: [entity?.company?.taxSystem || null],
        taxResidence: [entity?.company?.taxResidence || null],
        socialCapital: [entity?.company?.socialCapital || null],
        valorisation: [entity?.company?.valorisation || null],
        tva: [entity?.company?.tva || null],
        codeSiret: [entity?.company?.codeSiret || null],
        codeAPE: [entity?.company?.codeAPE || null],
        activitySector: [entity?.company?.activitySector || null],
        rcs: [entity?.company?.rcs || null],
        lieuImmatriculationRcs: [
          entity?.company?.lieuImmatriculationRcs || null,
        ],
        societeCotee: [
          !_.isNil(entity?.company?.societeCotee)
            ? entity?.company?.societeCotee
            : false,
        ],
        societeCoteeMarche: [entity?.company?.societeCoteeMarche || null],
        bilanCA: [entity?.company?.bilanCA || null],
        bilanNetResult: [entity?.company?.bilanNetResult || null],
        bilanTresory: [entity?.company?.bilanTresory || null],
        bilanDebt: [entity?.company?.bilanDebt || null],
        bilanEquity: [entity?.company?.bilanEquity || null],
        bilanTax: [entity?.company?.bilanTax || null],
        bilanTotalBilan: [entity?.company?.bilanTotalBilan || null],

        bilanCAN1: [entity?.company?.bilanCAN1 || null],
        bilanNetResultN1: [entity?.company?.bilanNetResultN1 || null],
        bilanTresoryN1: [entity?.company?.bilanTresoryN1 || null],
        bilanDebtN1: [entity?.company?.bilanDebtN1 || null],
        bilanEquityN1: [entity?.company?.bilanEquityN1 || null],
        bilanTaxN1: [entity?.company?.bilanTaxN1 || null],
        bilanTotalBilanN1: [entity?.company?.bilanTotalBilanN1 || null],

        bilanCAN2: [entity?.company?.bilanCAN2 || null],
        bilanNetResultN2: [entity?.company?.bilanNetResultN2 || null],
        bilanTresoryN2: [entity?.company?.bilanTresoryN2 || null],
        bilanDebtN2: [entity?.company?.bilanDebtN2 || null],
        bilanEquityN2: [entity?.company?.bilanEquityN2 || null],
        bilanTaxN2: [entity?.company?.bilanTaxN2 || null],
        bilanTotalBilanN2: [entity?.company?.bilanTotalBilanN2 || null],

        addressSiegeSocial: buildAddressGroup(
          entity?.company?.addressSiegeSocial,
          formBuilder,
        ),
        addressSiegeAdministratif: buildAddressGroup(
          entity?.company?.addressSiegeAdministratif,
          formBuilder,
        ),
        beneficialOwner: formBuilder.array(
          beneficialOwnerForm,
          Validators.nullValidator,
        ),
      }),
    });

    return formBuilderGroup;
  },
};
function buildAddressGroup(
  item: {
    street: string;
    street2: string;
    zipCode: string;
    city: string;
    cedex: string;
    country: string;
  },
  formBuilder: UntypedFormBuilder,
): UntypedFormGroup {
  return formBuilder.group(
    {
      street: [item?.street || null],
      zipCode: [item?.zipCode || null],
      city: [item?.city || null],
      country: [
        item?.country
          ? {
              value: item?.country,
              valueGb: item?.country,
            }
          : null,
      ],
    },
    Validators.nullValidator,
  );
}
function buildBeneficialOwnerFormArray(
  formBuilder: UntypedFormBuilder,
  beneficialOwners: CompanyBeneficialOwner[],
): UntypedFormGroup[] {
  let beneficialOwnerForm: UntypedFormGroup[] = [];

  if (beneficialOwners?.length) {
    _.forEach(beneficialOwners, beneficialOwner =>
      beneficialOwnerForm.push(
        buildBeneficialOwnerGroup(beneficialOwner, formBuilder),
      ),
    );
  }

  return beneficialOwnerForm;
}

function buildBeneficialOwnerGroup(
  item: CompanyBeneficialOwner,
  formBuilder: UntypedFormBuilder,
): UntypedFormGroup {
  return formBuilder.group({
    companyId: [item?.companyId || null],
    id: [item?.id || null],
    representativeFunction: [item?.representativeFunction || null],
    userFirstName: [item?.userFirstName || null],
    userId: [item?.userId || null],
    userLastName: [item?.userLastName || null],
    userSharePercentage: [item?.userSharePercentage || null],
    userBirthDate: [item?.userBirthDate || null],
    userBirthPlace: [item?.userBirthPlace || null],
    userNationality: [item?.userNationality || null],
    userTaxResidence: [item?.userTaxResidence || null],
    userPhone: [item?.userPhone || null],
    userEmail: [item?.userEmail || null],
    userTitle: [item?.userTitle || null],
    usPerson: [item?.usPerson || false],
    userBirthDepartment: [item?.userBirthDepartment || null],
    address: formBuilder.group({
      city: [item?.address?.addressCity || null],
      country: [item?.address?.addressCountry || null],
      street: [item?.address?.addressStreet || null],
      street2: [
        item?.address?.addressStreet2 || null,
        Validators.nullValidator,
      ],
      zipCode: [item?.address?.addressZipCode || null],
    }),
    antiMoneyLaundering: formBuilder.group({
      id: [item?.antiMoneyLaundering?.id || null],
      accountId: [item?.antiMoneyLaundering?.accountId || null],
      ownerId: [item?.antiMoneyLaundering?.ownerId || null],
      beneficialOwnerId: [
        item?.antiMoneyLaundering?.beneficialOwnerId || item?.id,
      ],
      profile: [item?.antiMoneyLaundering?.profile || 'PHYSICAL'],
      ppe: [
        _.isNil(item?.antiMoneyLaundering?.ppe)
          ? false
          : item?.antiMoneyLaundering?.ppe,
      ],
      adresseDomiciliation: [
        _.isNil(item?.antiMoneyLaundering?.adresseDomiciliation)
          ? false
          : item?.antiMoneyLaundering?.adresseDomiciliation,
      ],
      fortuneInfluent: [
        _.isNil(item?.antiMoneyLaundering?.fortuneInfluent)
          ? false
          : item?.antiMoneyLaundering?.fortuneInfluent,
      ],
      secteurRisqueCorruption: [
        _.isNil(item?.antiMoneyLaundering?.secteurRisqueCorruption)
          ? false
          : item?.antiMoneyLaundering?.secteurRisqueCorruption,
      ],
      discretionInhabituelle: [
        _.isNil(item?.antiMoneyLaundering?.discretionInhabituelle)
          ? false
          : item?.antiMoneyLaundering?.discretionInhabituelle,
      ],
      operationPaysGafi: [
        _.isNil(item?.antiMoneyLaundering?.operationPaysGafi)
          ? false
          : item?.antiMoneyLaundering?.operationPaysGafi,
      ],
      fondPaysGafi: [
        _.isNil(item?.antiMoneyLaundering?.fondPaysGafi)
          ? false
          : item?.antiMoneyLaundering?.fondPaysGafi,
      ],
      operationPaysNonCooperatif: [
        _.isNil(item?.antiMoneyLaundering?.operationPaysNonCooperatif)
          ? false
          : item?.antiMoneyLaundering?.operationPaysNonCooperatif,
      ],
      fondPaysNonCooperatif: [
        _.isNil(item?.antiMoneyLaundering?.fondPaysNonCooperatif)
          ? false
          : item?.antiMoneyLaundering?.fondPaysNonCooperatif,
      ],
      personneListeGelsDesAvoirs: [
        _.isNil(item?.antiMoneyLaundering?.personneListeGelsDesAvoirs)
          ? false
          : item?.antiMoneyLaundering?.personneListeGelsDesAvoirs,
      ],
      fondListeGelsDesAvoirs: [
        _.isNil(item?.antiMoneyLaundering?.fondListeGelsDesAvoirs)
          ? false
          : item?.antiMoneyLaundering?.fondListeGelsDesAvoirs,
      ],
      versementPeePerco: [
        _.isNil(item?.antiMoneyLaundering?.versementPeePerco)
          ? false
          : item?.antiMoneyLaundering?.versementPeePerco,
      ],
      produitsAtypiques: [
        _.isNil(item?.antiMoneyLaundering?.produitsAtypiques)
          ? false
          : item?.antiMoneyLaundering?.produitsAtypiques,
      ],
      controleActifsFonds: [
        _.isNil(item?.antiMoneyLaundering?.controleActifsFonds)
          ? false
          : item?.antiMoneyLaundering?.controleActifsFonds,
      ],
      compteTitreAugmentationCapital: [
        _.isNil(item?.antiMoneyLaundering?.compteTitreAugmentationCapital)
          ? false
          : item?.antiMoneyLaundering?.compteTitreAugmentationCapital,
      ],
      primeAnnuelleUnique: [
        _.isNil(item?.antiMoneyLaundering?.primeAnnuelleUnique)
          ? false
          : item?.antiMoneyLaundering?.primeAnnuelleUnique,
      ],
      contratPrevoyanceSante: [
        _.isNil(item?.antiMoneyLaundering?.contratPrevoyanceSante)
          ? false
          : item?.antiMoneyLaundering?.contratPrevoyanceSante,
      ],
      assuranceEmprunteur: [
        _.isNil(item?.antiMoneyLaundering?.assuranceEmprunteur)
          ? false
          : item?.antiMoneyLaundering?.assuranceEmprunteur,
      ],
      contratAssuranceSansClauseRachat: [
        _.isNil(item?.antiMoneyLaundering?.contratAssuranceSansClauseRachat)
          ? false
          : item?.antiMoneyLaundering?.contratAssuranceSansClauseRachat,
      ],
      contratAnonyme: [
        _.isNil(item?.antiMoneyLaundering?.contratAnonyme)
          ? false
          : item?.antiMoneyLaundering?.contratAnonyme,
      ],
      produitsImmobiliersLuxe: [
        _.isNil(item?.antiMoneyLaundering?.produitsImmobiliersLuxe)
          ? false
          : item?.antiMoneyLaundering?.produitsImmobiliersLuxe,
      ],
    }),
  });
}
